/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  emailRegex,
  notification,
  passwordRegex,
  ROUTES,
} from '../../../assets/constants/strings';
import { registerUser } from '../../../store/User/userActions';
import { REGISTER } from '../../../store/User/userTypes';
import AuthLoader from '../../Loader/Auth';
import './style.scoped.scss';

const mapStateToProps = (state) => ({
  user: state.user.user,
  loading: state.user.loading,
});

const mapDispatchToProps = { registerUser };

const ApiSignUpForm = ({
  user,
  handleUserJoined,
  registerUser,
  loading,
  isSmallScreen,
}) => {
  // form data
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showConf, setShowConf] = useState(false);
  const [organisation, setOrganisation] = useState('');

  const [showPasswordError, setShowPasswordError] = useState(false);
  const [showConfirmPasswordError, setShowConfirmPasswordError] =
    useState(false);
  // Email already has an account → guide to login (one account, add the
  // product there) instead of dead-ending the signup.
  const [existingEmail, setExistingEmail] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (
      !emailRegex(email) ||
      !passwordRegex(password) ||
      password !== confirmPassword
    ) {
      notification(
        'danger',
        'Invalid Information.',
        'Please review any fields marked in red.',
        undefined,
        3.5
      );
    } else {
      registerUser({
        firstName: firstName,
        lastName: lastName,
        email: email,
        password: password,
        confirmPassword: confirmPassword,
        organisation: organisation === '' ? null : organisation,
        // accountType is the BUYER type only; the product line is explicit.
        accountType: 'individual',
        productLine: 'DeveloperApi',
      });
    }
  };

  useEffect(() => {
    if (user && user.request === REGISTER && user.success === true)
      handleUserJoined();
    else if (user && user.reason && user.request === REGISTER) {
      if (user.reason.toLowerCase().includes('already registered')) {
        setExistingEmail(true);
        notification(
          'info',
          'You already have an account.',
          'Log in to add the Developer API to your existing account.'
        );
      } else {
        notification('info', 'Could not register user.', user.reason);
      }
    }
  }, [user]);

  const handlePassword = () => {
    if (passwordRegex(password)) setShowPasswordError(false);
    else setShowPasswordError(true);
  };

  const handleConfirmPassword = () => {
    if (confirmPassword.length > 0) {
      if (password !== confirmPassword) setShowConfirmPasswordError(true);
      else setShowConfirmPasswordError(false);
    }
  };

  return (
    <React.Fragment>
      {!isSmallScreen && (
        <div className='d-flex justify-content-center w-100'>
          <b className='mr-3'>Already have an account?</b>
          <Link to={`${ROUTES.LOGIN}?portal=api`}>{`Sign In`}</Link>
        </div>
      )}
      <div className='account__card d-flex justify-content-center align-items-center mt-4'>
        <div className='account__card__create'>
          {isSmallScreen && (
            <div className='d-flex justify-content-center w-100'>
              <b className='mr-3'>Already have an account?</b>
              <Link to={`${ROUTES.LOGIN}?portal=api`}>{`Sign In`}</Link>
            </div>
          )}
          {existingEmail && (
            <div className='alert alert-info mt-3 mb-0' role='alert'>
              This email already has a RegulationCity account — no need to
              create a new one.{' '}
              <Link to={`${ROUTES.LOGIN}?portal=api`}>
                <b>Log in to add the Developer API to your account.</b>
              </Link>
            </div>
          )}
          <form
            onSubmit={handleSubmit}
            className='mt-3 text-center'
            autoComplete='off'
          >
            <div className='form-group mb-3'>
              <input
                className='form-control'
                placeholder='First Name'
                id='FirstName'
                onChange={(e) => setFirstName(e.target.value)}
                value={firstName}
                maxLength={35}
                required
              />
            </div>
            <div className='form-group mb-3'>
              <input
                className='form-control'
                placeholder='Last Name'
                id='LastName'
                onChange={(e) => setLastName(e.target.value)}
                value={lastName}
                maxLength={35}
                required
              />
            </div>
            <div className='form-group mb-3'>
              <input
                className={`form-control${
                  email.length === 0
                    ? ''
                    : emailRegex(email)
                    ? ' is-valid'
                    : ' is-invalid'
                }`}
                placeholder='Email'
                type='email'
                id='Email'
                onChange={(e) => setEmail(e.target.value)}
                value={email}
                maxLength={320}
                required
              />
            </div>
            <div className='form-group mb-3 position-relative'>
              <input
                className={`form-control${
                  password.length === 0
                    ? ''
                    : passwordRegex(password)
                    ? ' is-valid'
                    : ' is-invalid'
                }`}
                placeholder='Password'
                type={showPass ? 'text' : 'password'}
                id='Password'
                onChange={(e) => setPassword(e.target.value)}
                value={password}
                required
                onBlur={handlePassword}
                onFocus={() => setShowPasswordError(false)}
              />
              {password.length > 0 ? (
                showPass ? (
                  <FaEyeSlash
                    className='password-visibility'
                    title='Hide Password'
                    onClick={() => setShowPass(false)}
                  />
                ) : (
                  <FaEye
                    className='password-visibility'
                    title='Show Password'
                    onClick={() => setShowPass(true)}
                  />
                )
              ) : null}
              {showPasswordError && (
                <span style={{ color: '#dc3545' }}>
                  <b>
                    Your password does not meet the security criteria outlined
                    below. Please review and create a new password.
                  </b>
                </span>
              )}
            </div>
            <div className='form-group position-relative mb-3'>
              <input
                className={`form-control${
                  confirmPassword.length === 0
                    ? ''
                    : confirmPassword === password
                    ? ' is-valid'
                    : ' is-invalid'
                }`}
                placeholder='Confirm Password'
                type={showConf ? 'text' : 'password'}
                id='ConfirmPassword'
                onChange={(e) => setConfirmPassword(e.target.value)}
                value={confirmPassword}
                required
                onBlur={handleConfirmPassword}
                onFocus={() => setShowConfirmPasswordError(false)}
              />
              {confirmPassword.length > 0 ? (
                showConf ? (
                  <FaEyeSlash
                    className='password-visibility'
                    title='Hide Password'
                    onClick={() => setShowConf(false)}
                  />
                ) : (
                  <FaEye
                    className='password-visibility'
                    title='Show Password'
                    onClick={() => setShowConf(true)}
                  />
                )
              ) : null}
              {showConfirmPasswordError && (
                <span style={{ color: '#dc3545' }}>
                  <b>Password does not match.</b>
                </span>
              )}
            </div>
            <div className='form-group mb-3'>
              <input
                className='form-control'
                placeholder='Company Name'
                id='CompanyName'
                type='text'
                onChange={(e) => setOrganisation(e.target.value)}
                value={organisation}
                required={true}
              />
            </div>
            <div className='form-group mb-3'>
              <div className='checkbox'>
                <input
                  type='checkbox'
                  className='form-control'
                  id='termsAndConditions'
                  required
                />
                <label htmlFor='termsAndConditions'>
                  I have read and accepted the{' '}
                  <a
                    href='https://www.regulationcity.com/terms-conditions/'
                    target='_blank'
                    rel='noreferrer'
                  >
                    {`Terms & Conditions`}
                  </a>{' '}
                  &{' '}
                  <a
                    href='https://www.regulationcity.com/privacy-policy/'
                    target='_blank'
                    rel='noreferrer'
                  >
                    {`Privacy & Cookies policy`}
                  </a>
                  .
                </label>
              </div>
            </div>
            <button type='submit'>
              {loading ? 'Creating Account' : 'Create Account'}
              {loading ? <AuthLoader /> : null}
            </button>
          </form>
        </div>
      </div>
    </React.Fragment>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(ApiSignUpForm);
